import SalesForceApiService from '@/api/salesforce_api_service';

export default {
  getSfContact(args) {
    const { id } = args;
    return new SalesForceApiService().get(`/user/salesforce/sf_contacts/${id}`);
  },
};
